export const SocialLinks = {
  telegram: 'https://t.me/cyberkoalas',
  telegramSupport: 'https://t.me/CyberKoala_support',
  discord: 'https://discord.gg/pRDfxyfpF9',
  youtube: 'https://www.youtube.com/channel/UCfEBnO2ZWyDHnN6bQSSlg1w',
  linkedin: 'https://www.linkedin.com/company/85986263/',
  talksy: 'https://talksy.ru/invite/18608f2c-64ad-4d55-bc93-ed9b4ce4b1bc',
  vk: 'https://vk.com/cyberkoala',
  vkPublicId: '-213871913',
  x: 'https://x.com/lrn4_ru',
  ok: 'https://ok.ru/group/70000002076011',
  github: 'https://github.com/CyberKoalaStudios',
  facebook: 'https://www.facebook.com/cyberkoalastudios',
  whatsapp: 'https://wa.me/79771860163',
  max: 'https://max.ru/id9729326938_biz',
  dzen: 'https://dzen.ru/cyberkoalastudios.com',
  email: 'mailto:contact@cyberkoalastudios.com',
  emailText: 'contact@cyberkoalastudios.com',
  tel: 'tel:+79771860163',
  telText: '+79771860163',
};
